var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add"},[_c('button',{staticClass:"button button--border add__button",on:{"click":function($event){$event.preventDefault();return _vm.$emit('add')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }